// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file branch/get_stock_points.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { StockPoint, StockPointActivity } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetStockPointsRequest
 */
export class GetStockPointsRequest extends Message<GetStockPointsRequest> {
  /**
   * Optional: Start date for filtering activity
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * Optional: End date for filtering activity
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  constructor(data?: PartialMessage<GetStockPointsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetStockPointsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStockPointsRequest {
    return new GetStockPointsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStockPointsRequest {
    return new GetStockPointsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStockPointsRequest {
    return new GetStockPointsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStockPointsRequest | PlainMessage<GetStockPointsRequest> | undefined, b: GetStockPointsRequest | PlainMessage<GetStockPointsRequest> | undefined): boolean {
    return proto3.util.equals(GetStockPointsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetStockPointsResponse
 */
export class GetStockPointsResponse extends Message<GetStockPointsResponse> {
  /**
   * List of stock points
   *
   * @generated from field: repeated com.neulink.pharmacy.StockPoint stock_points = 1;
   */
  stockPoints: StockPoint[] = [];

  /**
   * Activity details for each stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.StockPointActivity stock_point_activity = 2;
   */
  stockPointActivity: StockPointActivity[] = [];

  constructor(data?: PartialMessage<GetStockPointsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetStockPointsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stock_points", kind: "message", T: StockPoint, repeated: true },
    { no: 2, name: "stock_point_activity", kind: "message", T: StockPointActivity, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStockPointsResponse {
    return new GetStockPointsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStockPointsResponse {
    return new GetStockPointsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStockPointsResponse {
    return new GetStockPointsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStockPointsResponse | PlainMessage<GetStockPointsResponse> | undefined, b: GetStockPointsResponse | PlainMessage<GetStockPointsResponse> | undefined): boolean {
    return proto3.util.equals(GetStockPointsResponse, a, b);
  }
}

